import { PostHogProvider, PostHogErrorBoundary } from "@posthog/react";
import { ReactNode } from "react";

type PostHogProviderWrapperProps = {
  children: ReactNode;
};

const PostHogFallback = ({
  error: _error,
}: {
  error: unknown;
  componentStack: string;
  exceptionEvent?: unknown;
}) => {
  return (
    <div className="flex min-h-screen items-center justify-center p-4">
      <div className="text-center">
        <h1 className="mb-4 text-2xl font-bold">Something went wrong</h1>
        <p className="mb-4 text-gray-600">
          We&apos;ve been notified and are working on fixing this issue.
        </p>
        <button
          onClick={() => window.location.reload()}
          className="rounded bg-blue-600 px-4 py-2 text-white hover:bg-blue-700"
        >
          Reload Page
        </button>
      </div>
    </div>
  );
};

export function PostHogProviderWrapper({
  children,
}: PostHogProviderWrapperProps) {
  return (
    <PostHogProvider
      apiKey={import.meta.env.VITE_PUBLIC_POSTHOG_KEY}
      options={{
        api_host: import.meta.env.VITE_PUBLIC_POSTHOG_PROXY,
        ui_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
        defaults: "2025-05-24",
        // PostHog's /flags endpoint can take ~4s when its persons DB is slow;
        // the SDK default (3s) aborts the request and leaves every flag undefined.
        feature_flag_request_timeout_ms: 10000,
        capture_exceptions: true,
        debug: import.meta.env.MODE === "development",
        enable_recording_console_log: true,
        session_recording: {
          maskAllInputs: false,
          maskInputOptions: {
            password: true,
          },
          recordCrossOriginIframes: false,
        },
      }}
    >
      <PostHogErrorBoundary fallback={PostHogFallback}>
        {children}
      </PostHogErrorBoundary>
    </PostHogProvider>
  );
}
